export default {
  name: 'elearningLesson',
  namespace: 'elearning/lessons',
  methods: [
    {
      name: 'find',
      params: ['id'],
      successCode: 200,
      method: 'Get',
      url: ({ namespace, id }) => `/v1/${namespace}/${id}/`,
      urlParams: [ 'id' ]
    },
    {
      name: 'filter',
      params: ['data'],
      successCode: 200,
      method: 'Get',
      url: ({ namespace, }) => `/v1/${namespace}/`,
      urlParams: []
    },
    {
      name: 'enrollment',
      params: ['id'],
      successCode: 201,
      method: 'Post',
      url: ({ namespace, id }) => `/v1/${namespace}/${id}/enroll/`,
      urlParams: [ 'id' ],
      saga:false
    },
    {
      name: 'makeEnrollment',
      params: ['id'],
      successCode: 201,
      method: 'Post',
      url: ({ namespace, id }) => `/v1/${namespace}/${id}/enroll/`,
      urlParams: [ 'id' ]
    },
  ]
}